import { postJwtLogin } from '@framework/api-client';
import { FormHandler, FormItem, TextInput } from '@framework/form';
import { getNetworkErrorMessage, LoaderSpin, LoginCard } from '@framework/ui';
import { yup } from '@framework/validation';
import { Button, message, Space } from 'antd';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { AuthSource } from '../../AuthSource';
import { AuthActions } from '../../state/AuthSlice';

const LoginSchema = yup
  .object({
    fiscalNumber: yup
      .string()
      .required()
      .default(process.env.MOCK_LOGIN_FISCALNUMBER)
      .label('Codice Fiscale'),
  })
  .noUnknown()
  .required();

export interface IMockLoginFormProps {
  /**
   * Location da cui proviene la richiesta di login.
   */
  source: AuthSource;
  children?: React.ReactNode;
}

export function MockLoginForm(props: IMockLoginFormProps) {
  const dispatch = useDispatch();
  const [error, setError] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <>
      {props.children}
      <FormHandler
        layout="vertical"
        schema={LoginSchema}
        initialValues={LoginSchema.cast({}, { assert: false })}
        onSubmit={async values => {
          setIsLoading(true);
          try {
            // TODO far correggere lo swagger  (è sbagliato)
            const result: any = await postJwtLogin({
              headers: {
                codicefiscale: values.fiscalNumber,
                'X-Login-Provenienza': props.source,
              },
            });

            dispatch(
              AuthActions.loginSucceed({
                strategy: 'jwt',
                accessToken: result.accessToken,
                refreshToken: result.refreshToken,
                logoutUrls: result.logoutUrls ?? [],
              }),
            );
          } catch (e) {
            message.error(getNetworkErrorMessage(e, 'Si è verificato un errore durante il login.')); // prettier-ignore
            console.error(`[LoginForm] Errore durante il login`, { error: e });
            setError(e);
          } finally {
            setIsLoading(false);
          }
        }}
      >
        <LoaderSpin spinning={isLoading} transparent>
          <LoginCard title="" subTitle="Mock Login">
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <FormItem
                name="fiscalNumber"
                label="Codice Fiscale"
                layout={{ removeHelpMargin: true }}
              >
                <TextInput name="fiscalNumber" placeholder="Codice Fiscale" />
              </FormItem>
              <Button
                htmlType="submit"
                size="large"
                type="primary"
                block
                loading={isLoading}
                disabled={isLoading}
              >
                Login
              </Button>
            </Space>
          </LoginCard>
        </LoaderSpin>
      </FormHandler>
    </>
  );
}
